import { redirect } from '@tanstack/react-router';
import { Routes } from '@/routes.ts';

export const Route = createFileRoute({
	beforeLoad: () => {
		// Assumes that /dashboard is protected,
		// and will itself redirect to /login if the user isn't authenticated
		throw redirect({ to: Routes.DASHBOARD });
	},
});
